import { AnonymityLevel } from "./AnonymityLevel";

export const AnonymityDisplayMap = {
  [AnonymityLevel.ANONYMOUS]: "Anonymous",
  [AnonymityLevel.CONFIDENTIAL]: "Confidential",
  [AnonymityLevel.PUBLIC]: "Non-Anonymous",
  [AnonymityLevel.ANONYMIZE_PARTICIPANT_RESULTS]:
    "Participants can not see who responded or commented",
};
